import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  setData(name: string, value: string): void {
    localStorage.setItem(name, value);
  }

  getData(name: string): string {
    return localStorage.getItem(name);
  }

  removeData(name: string): void {
    localStorage.removeItem(name);
  }
}